module.exports = __webpack_public_path__ + "static/media/map-marker-alt-slash.038dcdd9.svg";